import { gql } from '@apollo/client';

import { insuranceFragment, hotelFragment } from 'store/fragments';
import REFUNDS_LEG from './REFUNDS_LEG';
import REFUNDS_FEE from './REFUNDS_FEE';

export default gql`
  query booking($reference: String!, $currency: Currency) {
    booking(reference: $reference) {
      createTimestamp
      confirmedTimestamp
      salesChannelCode
      reference
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      isBeingRepriced
      currency
      isLoyalty
      hasBeenSoldViaThirdPartySalesChannel
      payments {
        externalReference
        method
      }
      productFamily
      productFamilyGroup
      productFamilies {
        name
        code
        familyGroup
      }
      hotels(cancelled: false) {
        ...CompleteHotel
      }
      provisionallyCancelledHotels: hotels(cancelled: true, provisional: true) {
        ...CompleteHotel
      }
      allHotels: hotels {
        ...CompleteHotel
      }
      insurances {
        ...CompleteInsurance
      }
      outbound {
        ...RefundsLeg
      }
      inbound {
        ...RefundsLeg
      }
      pendingCancellationLegs {
        ...RefundsLeg
      }
      pendingCreationLegs {
        ...RefundsLeg
      }
      hotelCancellationFees: hotelCancellationFees(cancelled: false, provisional: true) {
        price
        itemRef
      }
      hotelMarginCancellationFees: hotelMarginCancellationFees(cancelled: false, provisional: true) {
        price
        itemRef
      }
      trainMarginCancellationFees {
        ...RefundsFee
      }
      customer {
        email
      }
      externalBookingReferences {
        source
        externalId
      }
      additionalDetails {
        value
        key
        itemRef
        passengerRef
      }
    }
  }

  ${REFUNDS_LEG}

  ${REFUNDS_FEE}

  ${insuranceFragment}

  ${hotelFragment}
`;
